import { useSessionMutation } from "../query/authenticated"
import type { ArtworkUploadEnvelope, ArtworkUploadResponse } from "../schemas"
import { syncArtworkToServer } from "./remote"

type ArtworkSyncVariables = {
  payload: ArtworkUploadEnvelope
  turnstileToken?: string | null
}

export function useArtworkSyncMutation() {
  return useSessionMutation<ArtworkUploadResponse, Error, ArtworkSyncVariables>(
    {
      mutationFn: ({ payload, turnstileToken }, { sessionToken }) =>
        syncArtworkToServer(payload, sessionToken, turnstileToken),
    },
  )
}
